import type { DocumentDataType } from './document-data-types';

export interface StagedDocument {
    id: string;
    fileName: string;
    file: File;
}

export enum DsUploadEmitErrorReason {
    INVALID_TYPE = 'invalid-type',
    SIZE_EXCEEDED = 'size-exceeded',
}

export interface DsUploadProps {
    disabled?: boolean;
    isLoading?: boolean;
    /** Defines if multiple files can be uploaded */
    multiple?: boolean;
    /** Defines the allowed file data types */
    dataTypes?: DocumentDataType[];
    /** Defines the size of the upload component dropzone */
    size?: 'full' | 'lg' | 'md' | 'collapsed';
    /** Defines the maximum file size in bytes */
    maxFileSize?: number;
    /** Defines if one or more files are required */
    required?: boolean;
}

export interface DsUploadEmits {
    'file-uploaded': [payload: { file: File }];
    'file-upload-error': [payload: { file: File; reason: DsUploadEmitErrorReason }];
}

export type DsUploadTrigger = 'dropzone' | 'file-input';

export type DsUploadClickTriggerSlotProps = (props: { triggerFilePicker: () => void }) => void;
